import React, { useState, useEffect } from "react";
import {
  makeStyles,
  withStyles,
  Button,
  Dialog,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  MenuItem,
  FormControl,
  Select,
  Tooltip,
} from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {
  isObjectEmpty,
  classStatusOptionList,
} from "../../../../utils/general";
import { addSelectClassData,setDuplicateSelectClassMessage } from "../../../../reduxSlices/selectClassSlice";
import localizedStrings from "../../../../utils/localize";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  formControl: {
    color: "white",
  },
  formRoot: {
    color: "white",
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ModalDialog = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [termsData, setTerms] = useState("");
  const [dptData, setDptData] = useState("");
  const [courseData, setCourseData] = useState("");
  const [tableMapData, setTableMapData] = useState([]);

  let modalData = useSelector((state) => state.selectClassData.modalData);
  const selectClassData = useSelector(
    (state) => state.selectClassData.selectClassData,
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChange = (event) => {
    const copyTableMapData = [...modalData];
    if (event.target.name === "term") {
      if (event.target.value?.length === 0) {
        const data = filterInAlphabeticalOrder(copyTableMapData);
        setTableMapData(data);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_termname === event.target.value,
        );
        const data = filterInAlphabeticalOrder(copyData);
        setTableMapData(data);
      }

      setTerms(event.target.value);
      setDptData("");
      setCourseData("");
    }
    if (event.target.name === "dept") {
      if (event.target.value?.length === 0) {
        const data = filterInAlphabeticalOrder(copyData);
        setTableMapData(data);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_departmentname === event.target.value,
        );
        const data = filterInAlphabeticalOrder(copyData);
        setTableMapData(data);
      }

      setDptData(event.target.value);
      setTerms("");
      setCourseData("");
    }
    if (event.target.name === "course") {
      if (event.target.value?.length === 0) {
        const data = filterInAlphabeticalOrder(copyTableMapData);
        setTableMapData(data);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_coursename === event.target.value,
        );
        const data = filterInAlphabeticalOrder(copyData);
        setTableMapData(data);
      }

      setCourseData(event.target.value);
      setDptData("");
      setTerms("");
    }
  };

  
const handleAddData = (ses_classid, ses_term, ses_courseid) => {
  if (ses_classid !== undefined) {
    // Check if course and term already exist in the array
    const courseAndTermExists = selectClassData.some(
      (data) => data.ses_courseid === ses_courseid && data.ses_term === ses_term
    );

    if(courseAndTermExists){
        dispatch(setDuplicateSelectClassMessage(true));
    }

    // Avoid adding if it already exists
    if (!courseAndTermExists) {
      const isClassAlreadyAdded = selectClassData.some(
        (data) => data.ses_classid === ses_classid
      );

      if (!isClassAlreadyAdded) {
        const copyTableMapData = [...tableMapData];
        const classToAdd = copyTableMapData.find(
          (data) => data.ses_classid === ses_classid
        );

        dispatch(addSelectClassData(classToAdd));
      }
    }
  }

  props.handleClose();
};


  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_termname === v.ses_termname) === i,
        );
      else if (field === "dept")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex(
              (t) => t.ses_departmentname === v.ses_departmentname,
            ) === i,
        );
      else if (field === "course")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_coursename === v.ses_coursename) === i,
        );
    }
    return [];
  };
  const filterInAlphabeticalOrder = (data) => {
    return data.sort((a, b) => {
      if (a.ses_institutionclassid < b.ses_institutionclassid) return -1; // A to Z order
      if (a.ses_institutionclassid > b.ses_institutionclassid) return 1;
      return 0;
    });
  };

  useEffect(() => {
    if (!isObjectEmpty(modalData)) {
      const removeEmptyObjmodalData = modalData?.filter(
        (value) => Object.keys(value).length !== 0,
      ); // Remove empty objects

      const sortedData = filterInAlphabeticalOrder(removeEmptyObjmodalData); // Sort the filtered data

      setTableMapData(sortedData);
    }
  }, [modalData]);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);

  function sorter(arr) {
    let array = arr.sort(function (a, b) {
      return a.props.value.localeCompare(b.props.value);
    });
    return array;
  }
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  function formatCredits(credits) {
    if (credits === 0) {
      return "0,00";
    } else {
      return credits
        ?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(".", ",");
    }
  }

  let tableData = "";
  let termData = "";
  let deptsData = "";
  let coursesData = "";

  if (modalData?.length != 0) {
    if (modalData) {
      if (modalData?.length > 0) {
        modalData = modalData?.filter(
          (value) => Object.keys(value).length !== 0,
        );

        tableData =
          tableMapData?.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                        <StyledTableCell>
                        {(element?.ses_classstatus === "Available" ||
                          element.ses_classstatus === "Wait List") &&
                        element.ses_classstatus != "Full" &&
                        element.ses_classstatus != "Cancelled" ? (
                          <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<AddIcon />}
                            style={{ textTransform: "capitalize" }}
                            onClick={() => handleAddData(element.ses_classid,element.ses_term,element.ses_courseid)}
                          >
                            {
                              localizedStrings.students.selectClasses.modalTable
                                .add
                            }
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<AddIcon />}
                            style={{ textTransform: "capitalize" }}
                            disabled={true}
                          >
                            {
                              localizedStrings.students.selectClasses.modalTable
                                .add
                            }
                          </Button>
                        )}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.class
                                }{" "}
                                - {element.ses_institutionclassid}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.startDate
                                }{" "}
                                -{" "}
                                {moment(element.ses_startdate).format(
                                  "YYYY-MM-DD",
                                )}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.endDate
                                }{" "}
                                -{" "}
                                {moment(element.ses_enddate).format(
                                  "YYYY-MM-DD",
                                )}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.room
                                }{" "}
                                - {element.ses_roomname}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button>
                            {element.ses_termname === undefined
                              ? ""
                              : element.ses_termname}{" "}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_departmentname === undefined
                          ? ""
                          : element.ses_departmentname}
                      </StyledTableCell>
                      <StyledTableCell>
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                component="body"
                                style={{ fontSize: "15px" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .description
                                }{" "}
                                - {element.ses_longdescription}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button style={{ textAlign: "left" }}>
                            {element.ses_institutionclassid ===
                            (undefined || null)
                              ? ""
                              : `${element?.ses_institutionclassid}- ${element?.ses_classname}`}
                            <br />
                            {element?.ses_roomname === (undefined || null)
                              ? ""
                              : `${element?.ses_roomname}`}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element?.ses_facultyname?.length > 0 ? (
                          <Typography variant="body2" display="block">
                            {element.ses_facultyname
                              .filter((name) => name !== null)
                              .join(", ")}
                          </Typography>
                        ) : null}
                      </StyledTableCell>
                      <StyledTableCell>
                        {formatCredits(element.ses_creditsavailable)}
                      </StyledTableCell>

                      <StyledTableCell>
                        {element?.ses_sessioncount &&
                        element?.ses_sessioncount != (undefined && null)
                          ? element?.ses_sessioncount
                          : 0}
                        /
                        {element?.ses_classcapacity &&
                        element?.ses_classcapacity != (undefined && null)
                          ? element?.ses_classcapacity
                          : 0}
                      </StyledTableCell>
                      <StyledTableCell>
                        {classStatusOptionList(element.ses_classstatus)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_startdate
                          ? moment(element.ses_startdate).format("YYYY-MM-DD")
                          : ""}
                        {element.ses_startdate != null ? " /" : ""}
                        <br />
                        {element.ses_schedule ? element.ses_schedule : ""}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.usb_classnote ? element.usb_classnote : ""}
                      </StyledTableCell>
                    
                    </StyledTableRow>
                  );
                })
            : null;

        termData = removeDuplicateFromObjects(modalData, "termName").map(
          (element, index) => (
            <MenuItem value={element.ses_termname} key={index}>
              {element.ses_termname}
            </MenuItem>
          ),
        );

        deptsData = removeDuplicateFromObjects(modalData, "dept").map(
          (element, index) => (
            <MenuItem value={element.ses_departmentname} key={index}>
              {element.ses_departmentname}
            </MenuItem>
          ),
        );
        deptsData = sorter(deptsData);

        coursesData = removeDuplicateFromObjects(modalData, "course").map(
          (element, index) => (
            <MenuItem value={element.ses_coursename} key={index}>
              {` ${element.ses_course}- ${element.ses_coursename}`}
            </MenuItem>
          ),
        );

        coursesData.sort(function (a, b) {
          return a.props.children.localeCompare(b.props.children);
        });
      }
    }
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  return (
    <Dialog
      onClose={props.handleClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
        {localizedStrings.students.selectClasses.modalTable.availableclasses}
      </DialogTitle>
      <DialogContent dividers>
        <TableContainer
          component={Paper}
          style={{ minHeight: "40vh", marginBottom: "10px" }}
        >
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
              <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.actions}
                </StyledTableCell>
                <StyledTableCell className={classes.formRoot}>
                  {localizedStrings.students.selectClasses.modalTable.term}
                  <br />
                  <FormControl className={classes.formControl}>
                    <Select
                      value={termsData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="term"
                    >
                      <MenuItem value="">
                        {" "}
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allTerms
                        }
                      </MenuItem>
                      {termData}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  {
                    localizedStrings.students.selectClasses.modalTable
                      .department
                  }
                  <FormControl className={classes.formControl}>
                    <Select
                      value={dptData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="dept"
                    >
                      <MenuItem value="">
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allDepartments
                        }
                      </MenuItem>
                      {deptsData}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.course}
                  <FormControl
                    className={classes.formControl}
                    style={{ display: "flex" }}
                  >
                    <Select
                      value={courseData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="course"
                    >
                      <MenuItem value="">
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allCourses
                        }
                      </MenuItem>
                      {coursesData}
                    </Select>
                  </FormControl>
                </StyledTableCell>

                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.faculty}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.credits}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.enrolled}
                </StyledTableCell>
                <StyledTableCell style={{ width: "18vh" }}>
                  {
                    localizedStrings.students.selectClasses.modalTable
                      .classStatus
                  }
                </StyledTableCell>
                <StyledTableCell style={{ width: "18vh" }}>
                  {
                    localizedStrings.students.selectClasses.modalTable
                      .firstClassMeeting
                  }{" "}
                  /
                  <br />
                  {localizedStrings.students.selectClasses.modalTable.schedule}
                </StyledTableCell>
                <StyledTableCell style={{ width: "18vh" }}>
                  {
                    localizedStrings.students.selectClasses.modalTable
                      .classNotes
                  }
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tableData}</TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={tableMapData?.length > 0 ? tableMapData?.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={
              <span style={{ textTransform: "none" }}>
                {localizedStrings.rows.rowsperpage}
              </span>
            }
            labelDisplayedRows={customLabelDisplayedRows}
          />
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.handleClose} color="primary">
          {localizedStrings.students.selectClasses.modalTable.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDialog;
